const e = "Select meeting type", n = "General", t = "1-on-1", s = "All Hands", o = "Interview", c = "Planning Session", i = "Catchup / Chat", a = "Knowledge Sharing", g = "Team Sync", l = "Client Meeting", r = "Workshop", _ = "Board Meeting", h = "Technical Review", m = "Crisis Management", p = {
  selectMeetingType: e,
  general_meeting: n,
  one_on_one: t,
  all_hands: s,
  interview: o,
  planning_session: c,
  catchup_coffee: i,
  knowledge_sharing: a,
  team_sync: g,
  client_meeting: l,
  workshop: r,
  board_meeting: _,
  technical_review: h,
  crisis_management: m
};
export {
  s as all_hands,
  _ as board_meeting,
  i as catchup_coffee,
  l as client_meeting,
  m as crisis_management,
  p as default,
  n as general_meeting,
  o as interview,
  a as knowledge_sharing,
  t as one_on_one,
  c as planning_session,
  e as selectMeetingType,
  g as team_sync,
  h as technical_review,
  r as workshop
};
